import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/DetailsNews/DetailsNewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OtherNewsSection"] */ "/app/src/components/layouts/DetailsNews/OtherNewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Footer/Footer.tsx");
